export default {
  metrics: {
    pickup: 'Pickup',
    internal_delivery: 'Internal delivery',
    external_delivery: 'External delivery',
  },
  events: {
    add_to_basket: 'Add item',
    begin_checkout: 'Proceed to checkout',
    begin_purchase: 'Initiate payment',
    complete_purchase: 'Complete payment',
    order_placed: 'Complete payment',
    view_item: 'View item',
  },
};
